import React, { useEffect, useState } from "react";
import { PageHeader, Card, Tag } from "../components/UI";
import DataTable from "../components/DataTable";
import { CheckCircle2, XCircle, ShieldCheck } from "lucide-react";
import api, { formatError } from "../lib/api";

export default function Approvals() {
  const [items, setItems] = useState([]);

  async function fetchItems() {
    const { data } = await api.get("/onboarding/approvals");
    setItems(data);
  }
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/onboarding/approvals");
        if (alive) setItems(data);
      } catch { /* swallow */ }
    })();
    return () => { alive = false; };
  }, []);

  async function approve(id) {
    try { await api.post(`/onboarding/approvals/${id}/approve`); await fetchItems(); }
    catch (e) { alert(formatError(e)); }
  }
  async function reject(id) {
    const reason = window.prompt("Reason for rejection?");
    if (!reason) return;
    try { await api.post(`/onboarding/approvals/${id}/reject`, { reason }); await fetchItems(); }
    catch (e) { alert(formatError(e)); }
  }

  const columns = [
    { key: "physio_code", label: "ERP ID", filter: "text", render: (r) => <span className="font-mono text-[12px]">{r.erp_outlet_id || r.physio_code}</span> },
    { key: "name", label: "Name", accessor: (r) => `${r.first_name} ${r.last_name}`, filter: "text",
      render: (r) => <div><div className="font-medium">{r.first_name} {r.last_name}</div><div className="text-[11px] text-slate-500">{r.specialty || "—"}</div></div> },
    { key: "mobile", label: "Mobile", filter: "text" },
    { key: "clinic_name", label: "Clinic", filter: "text" },
    { key: "city", label: "City", filter: "text" },
    { key: "source_of_enrollment", label: "Source", filter: "select", options: ["WhatsApp Onboarding", "DSE", "Self", "Campaign"] },
    { key: "created_at", label: "Submitted", render: (r) => new Date(r.created_at).toLocaleString() },
    { key: "actions", label: "", sortable: false, align: "right",
      render: (r) => (<div className="flex items-center justify-end gap-2">
        <button onClick={(e) => { e.stopPropagation(); approve(r.id); }} className="text-emerald-700 hover:underline text-[12px] inline-flex items-center gap-1" data-testid={`approve-${r.id}`}><CheckCircle2 size={12} /> Approve</button>
        <button onClick={(e) => { e.stopPropagation(); reject(r.id); }} className="text-rose-600 hover:underline text-[12px] inline-flex items-center gap-1" data-testid={`reject-${r.id}`}><XCircle size={12} /> Reject</button>
      </div>) },
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        kicker="Administration"
        title="Physio Onboarding Approvals"
        subtitle="Audit log of physio onboarding submissions. HO approval is no longer required (06/2026 policy change) — physios are auto-approved on ERP-validated onboarding. This page lists any legacy pending submissions for review."
        testId="approvals-page"
      />
      <Card>
        <DataTable columns={columns} data={items} rowKey="id"
          searchableKeys={["first_name", "last_name", "mobile", "clinic_name", "city", "physio_code"]}
          exportFilename="cbc-approvals" testIdPrefix="approvals" initialSort={{ key: "created_at", dir: "desc" }} />
        {items.length === 0 && <div className="text-center py-10 text-slate-500"><ShieldCheck size={24} className="mx-auto mb-2 text-emerald-600" />All onboarding requests are processed. ✨</div>}
      </Card>
    </div>
  );
}
